module.exports = __webpack_public_path__ + "img/subcurve3.a71e5042.svg";